import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import routes from "./routes";
import { Suspense, useState } from "react";
import { GlobalProvider } from "./context/Provider";
import isAuthenticated from "./utils/isAuthenticated";
import "semantic-ui-css/semantic.min.css";
import SideBar from "./components/Sidebar";
import "./app.css";
import Header from "./components/Header";

const RenderRoute = (route) => {
  const history = useHistory();

  document.title = route.title || "Portal Médicos";
  if (route.needsAuth && !isAuthenticated()) {
    history.push("/");
  }

  if (route.path === "/" || route.path === "/auth/login") {
    //sessionStorage.clear();
    route.SetSidebarOpen(false);
    document.body.className = "BodyLogin";
  } else {
    route.SetSidebarOpen(true);
    document.body.className = "";
  }

  return (
    <Route
      path={route.path}
      exact
      render={(props) => <route.component {...props} />}
    ></Route>
  );
};

function App() {
  const [sidebarOpen, SetSidebarOpen] = useState(true);

  return (
    <Router>
      <GlobalProvider>
        <div className="App">
          {sidebarOpen && <Header className="Header" />}
          {sidebarOpen && <SideBar className="SideBar" />}
          <div role="main">
            {/* Se coloca este div para poder acomodar el la grilla del Layout */}
            <Switch>
              <Suspense fallback={<p>Loading</p>}>
                <Switch>
                  {routes.map((route, index) => (
                    <RenderRoute
                      {...route}
                      key={index}
                      SetSidebarOpen={SetSidebarOpen}
                    />
                  ))}
                </Switch>
              </Suspense>
            </Switch>
          </div>
        </div>
      </GlobalProvider>
    </Router>
  );
}

export default App;
